(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('printDom', printDom);

    function printDom() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs, ctrl) {

                var target = attrs.target || '.print-dom-target';

                scope.printDomClick = function() {
                    var printElement =  document.createElement('div');
                    $(printElement).addClass('printSection');
                    document.body.append(printElement);
                    $(target).clone().appendTo(printElement);
                    var originalTitle = document.title;
                    document.title = attrs.title || 'Print';
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    window.print();
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    document.title = originalTitle;
                    $('.printSection').remove();
                }
            }
        };
    }
})();